import Axios from "axios";
import { host } from '../../inv';

/**
 * This function returns a list of the privileges.
 * @return {object[]}
 */
export const getGIZprivileges = () => {
  const privileges = [
    {
      sortNO: 1,
      id: 1,
      name: "Can see Beneficiary satisfaction",
      roleType: 1,
      checked: false
    },
    {
      sortNO: 2,
      id: 2,
      name: "Manage User",
      roleType: 1,
      checked: false
    },
  ];

  return privileges;
};

export const passwordManager = newValue => {
  if (newValue == "") {
    return [false, "Password field should not be empty"];
  } else if (newValue.length < 6) {
    return [false, "The passwored is too short"];
  } else if (newValue.search(/[A-Z]/) == -1) {
    return [
      false,
      "The passwored should contain at least one upper case letter"
    ];
  } else if (newValue.search(/[a-z]/) == -1) {
    return [
      false,
      "The passwored should contain at least one lower case letter"
    ];
  } else if (newValue.search(/[0-9]/) == -1) {
    return [false, "The passwored should contain at least one number"];
  } else {
    return [true, "The passwored is strong"];
  }
};

export const createNewEmployee = (data, callback) => {
  Axios.post(host + "/user/create", data).then(res =>
    callback(res.data)
  );
};

export const updateEmployee = (data, callback) => {
  Axios.post(host + "/user/update", data).then(res =>
    callback(res.data)
  );
};

export const updateStateEmployee = (data, callback) => {
  Axios.post("/user/changestate", data).then(res =>
    callback(res.data)
  );
};

export const getUsers = callback => {
  Axios.get(host + "/user/users").then(res => callback(res.data));
};

export const getNameByUsername = (username, callback) => {
  Axios.get(host + "/user/getnamebyusername/" + username).then(res =>
    callback(res.data)
  );
};

export const getUsersNames = callback => {
  Axios.get(host + "/user/getusersnames").then(res => {
    if (res.data && res.data.users && res.data.users.length > 0)
      callback(res.data);
  });
};

export const getUsersNameById = (id, callback) => {
  Axios.get(host + "/user/getusersname/" + id).then(res => {
    if (
      res &&
      res.data &&
      res.data.user &&
      res.data.user.hasOwnProperty("name")
    )
      callback(res.data.user);
  });
};

export const getUsersByState = (state, callback) => {
  Axios.post(host + "/user/getusersbystate/", { state }).then(res => {
    callback(res.data);
  });
};
